/** @jsx jsx */
import { Box } from '@bottlebooks/gatsby-theme-base/src';
import React from 'react';
import { jsx } from 'theme-ui';
import MainMenuDesktop from './MainMenuDesktop';
import MainMenuMobile from './MainMenuMobile';
import useMenuQuery from './useMenuQuery';

/**
 * @type {React.FC<{isScrolledDown?: boolean; hideSearch?: boolean; landingPage: string; locale: string; }>}
 */
const MainMenu = React.memo(function MainMenu({
  isScrolledDown = false,
  hideSearch,
  landingPage,
  locale,
  ...rest
}) {
  const menuItems = useMenuQuery({ locale });
  if (!menuItems?.length) return null;
  return (
    <Box sx={{ width: '100%' }}>
      <MainMenuDesktop
        sx={{ display: ['none', null, 'inherit'] }}
        menuItems={menuItems}
        landingPage={landingPage}
        isScrolledDown={isScrolledDown}
        hideSearch={hideSearch}
        locale={locale}
        {...rest}
      />
      <MainMenuMobile
        sx={{ display: ['inherit', null, 'none'] }}
        menuItems={menuItems}
        landingPage={landingPage}
        isScrolledDown={isScrolledDown}
        locale={locale}
        {...rest}
      />
    </Box>
  );
});
export default MainMenu;
